import * as angular from 'angular';

import { GuidObjectType, ComponentDefinition } from '../../../models';

class ObjectIconController implements angular.IComponentController {
    readonly large;
    readonly objectType: GuidObjectType;
    readonly viewModel;

    static $inject = [];
}

export const wtObjectIcon: ComponentDefinition = {
    componentId: 'wtObjectIcon',
    controller: ObjectIconController,
    template: require('./objectIcon.component.html'),
    controllerAs: 'vm',
    bindings: {
        large: '<?',
        objectType: '<', // enum GuidObjectType
        viewModel: '<?'
    }
};
